module.exports = __webpack_public_path__ + "img/des.20d79b03.jpg";